import { useTexts } from '@/feature/lang';
import Button from '@mui/material/Button';
import { Box } from '../Box';
import Divider from '../Divider';
import { Form } from '../Form';
import {
  PopperContainer,
  PopperContent,
  PopperFooter,
  PopperHeading,
} from '../Popper';
import Translate from '../Translate';
import DateRangeFilter from './DateRangeFilter';
import DateRangePresets from './DateRangePresets';
import { useDateRange } from './DateRangeProvider';

const Layout = ({ onClose }: PopperContentProps) => {
  const { onChange, presetOptions } = useDateRange();
  const allTexts = useTexts();
  const texts = allTexts.component.dateRange;

  const onConfirm = () => {
    onChange();
    onClose?.();
  };

  return (
    <Form onSubmit={onConfirm}>
      <PopperContainer width="auto">
        <PopperHeading>
          <Translate text={texts.header} />
        </PopperHeading>
        <PopperContent>
          <Box display="flex" gap={2}>
            {presetOptions.length > 0 && (
              <>
                <DateRangePresets />
                <Divider orientation="vertical" flexItem variant="middle" />
              </>
            )}
            <DateRangeFilter />
          </Box>
        </PopperContent>
        <PopperFooter>
          <Box display="flex" justifyContent="flex-end" alignItems="center">
            <Button
              variant="outlined"
              onClick={onClose}
              color="inherit"
              sx={{ mr: 2 }}
            >
              <Translate text={texts.actions.cancel.label} />
            </Button>
            <Button variant="contained" color="primary" type="submit">
              <Translate text={texts.actions.ok.label} />
            </Button>
          </Box>
        </PopperFooter>
      </PopperContainer>
    </Form>
  );
};

export default Layout;
